module.exports = __webpack_public_path__ + "img/Left_five.3aa911b7.svg";